import { QueryClient } from "@tanstack/vue-query";

/** Shared so the auth store can drop cached tenant data on logout. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5_000,
    },
  },
});
